import {
  PaymentEnum,
  PaymentMethodCodeEnum,
  PaymentMethodEnum,
} from 'app/shared/enums';

const shouldShowApplePay = () => {
  if (typeof navigator === 'undefined') return true;

  const isAndroidDevice = /android/i.test(
    navigator.userAgent || navigator.vendor || ''
  );

  if (isAndroidDevice) return false;

  return true;
};

const shouldShowGooglePay = () => {
  if (typeof navigator === 'undefined') return true;

  const isIphoneDevice = /iphone/i.test(
    navigator.userAgent || navigator.vendor || ''
  );

  if (isIphoneDevice) return false;

  return true;
};

export const paymentMethodDictionary = [
  { key: PaymentMethodEnum.Blik, value: PaymentEnum.BLIK },
  {
    key: PaymentMethodEnum.OnlineTransfer,
    value: PaymentEnum.OnlineOrTraditionalTransfer,
  },
  { key: PaymentMethodEnum.Card, value: PaymentEnum.CARD },
  { key: PaymentMethodCodeEnum.PayPo, value: PaymentEnum.PayPoLong },
  ...(shouldShowGooglePay()
    ? [{ key: PaymentMethodCodeEnum.GPay, value: PaymentEnum.GPay }]
    : []),
  ...(shouldShowApplePay()
    ? [{ key: PaymentMethodCodeEnum.ApplePay, value: PaymentEnum.ApplePay }]
    : []),
];
